module.exports = __webpack_public_path__ + "static/media/FMBCH-CR-T0-A1-CF-CC-F43.11047b57.png";